// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".Comments-cls1___e4fce0133a5481aa702{/*!*/}.Comments-cls2__fd6546a830dc0cb02ef6{color:#535366;color:var(--text-secondary, #535366);line-height:20px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "Comments-cls1___e4fce0133a5481aa702",
	"cls2": "Comments-cls2__fd6546a830dc0cb02ef6 Comments-cls1___e4fce0133a5481aa702"
};
export default ___CSS_LOADER_EXPORT___;
